import { createRouter, createWebHashHistory } from 'vue-router'
import {getToken} from "@/utils/auth";
const mainRoutes = [
    {
        path: "/home",
        name: "home",
        component: () => import("@/views/home"),
        meta: {
            title: "主页",
        },
    },
    {
        path: "/",
        name: "",
        component: () => import("@/views/navigation"),
        meta: {
            title: "navigation",
            keepAlive: true // 需要缓存
        },
    },
    {
        path: "/login",
        name: "login",
        component: () => import("@/views/login"),
        meta: {
            title: "登录",
        },
    },
    {
        path: "/incidentManagement",
        name: "incidentManagement",
        component: () => import("@/views/workbench-farm/incidentManagement"),
        meta: {
            title: "工作台",
        },
    },
    {
        path: "/dayManagement",
        name: "dayManagement",
        component: () => import("@/views/workbench-farm/incidentManagement/dayManagement"),
        meta: {
            title: "工作台",
        },
    },
    {
        path: "/workbench",
        name: "workbench",
        component: () => import("@/views/workbench"),
        meta: {
            title: "工作台",
        },
    },
    {
        path: "/plantAdmin",
        name: "plantAdmin",
        component: () => import("@/views/workbench/productionManagement/plantAdmin"),
        meta: {
            title: "工作台",
        },
        children: [
            {
                path: "plantNewAdd",
                component: () => import("@/views/workbench/productionManagement/plantAdmin/plantNewAdd")
            },
        ]
    },
    {
        path: "/plantNewAdd",
        name: "plantNewAdd",
        component: () => import("@/views/workbench/productionManagement/plantAdmin/plantNewAdd"),
        meta: {
            title: "工作台",
        },
    },
    {
        path: "/plantHistory",
        name: "plantHistory",
        component: () => import("@/views/workbench/productionManagement/plantAdmin/plantHistory"),
        meta: {
            title: "工作台",
        },
    },
    {
        path: "/productionLog",
        name: "productionLog",
        component: () => import("@/views/workbench/productionManagement/productionLog"),
        meta: {
            title: "生产日志",
        },
    },
    {
        path: "/storage",
        name: "storage",
        component: () => import("@/views/workbench/productionManagement/storage"),
        meta: {
            title: "生产日志",
        },
    },
    {
        path: "/addStorage",
        name: "addStorage",
        component: () => import("@/views/workbench/productionManagement/storage/addStorage"),
        meta: {
            title: "工作台",
        },
    },
    {
        path: "/useStorage",
        name: "useStorage",
        component: () => import("@/views/workbench/productionManagement/storage/useStorage"),
        meta: {
            title: "工作台",
        },
    },
    {
        path: "/myTask",
        name: "myTask",
        component: () => import("@/views/workbench/productionManagement/myTask"),
        meta: {
            title: "工作台",
        },
    },
    {
        path: "/addTask",
        name: "addTask",
        component: () => import("@/views/workbench/productionManagement/myTask/addTask"),
        meta: {
            title: "工作台",
        },
    },
    {
        path: "/manageTask",
        name: "manageTask",
        component: () => import("@/views/workbench/productionManagement/myTask/manageTask"),
        meta: {
            title: "工作台",
        },
    },
    {
        path: "/myTaskDetail",
        name: "myTaskDetail",
        component: () => import("@/views/workbench/productionManagement/myTask/myTaskDetail"),
        meta: {
            title: "工作台",
        },
    },
    {
        path: "/purchaseLog",
        name: "purchaseLog",
        component: () => import("@/views/workbench/productionManagement/purchaseLog"),
        meta: {
            title: "工作台",
        },
    },
    {
        path: "/addPurchase",
        name: "addPurchase",
        component: () => import("@/views/workbench/productionManagement/purchaseLog/addPurchase"),
        meta: {
            title: "工作台",
        },
    },
    {
        path: "/personalCenter",
        name: "personalCenter",
        component: () => import("@/views/personalCenter"),
        meta: {
            title: "个人中心",
        },
    },
    {
        path: "/changePassword",
        name: "changePassword",
        component: () => import("@/views/changePassword"),
        meta: {
            title: "修改密码",
        },
    },
    {
        path: "/batteryInformation",
        name: "batteryInformation",
        component: () => import("@/views/batteryInformation"),
        meta: {
            title: "电池室信息",
        },
    },
    {
        path: "/messageCenter",
        name: "messageCenter",
        component: () => import("@/views/messageCenter"),
        meta: {
            title: "消息中心",
        },
    },
];


const router = createRouter({
    history: createWebHashHistory(), // hash history
    scrollBehavior: () => ({ y: 0 }),
    base: __dirname,
    routes: mainRoutes,
});
// // 消除重复跳转警告
// const originalPush = router.prototype.push;
// router.prototype.push = function push(location) {
//     return originalPush.call(this, location).catch((err) => err);
// };


router.beforeEach((to, from, next) => {
    if (to.path !== '/login' && !getToken()) {
        next('/login'); // 未登录时跳转至登录页面
    } else if (to.path === '/login' && getToken()){
        next('/home');
    }else {
        next();
    }
    next();

});

export function resetRouter() {
    const newRouter = router
    router.matcher = newRouter.matcher // reset router
}

export default router;
